<template>
    <div class="flex-row align-items-center login">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="6">
                    <b-card no-body class="p-2">
                        <b-card-body>
                            <h2 class="mb-4">To get started, tell us about your project.</h2>

                            <b-form-group 
                                label="What's the voice over for?" 
                                required 
                            >
                                <multiselect 
                                    v-model="application" 
                                    :allowEmpty="false" 
                                    :options="applications" 
                                    label="name"
                                    selectLabel=""
                                    selectedLabel=""
                                    deselectLabel=""
                                    >
                                </multiselect>
                            </b-form-group>

                            <b-button type="submit" class="float-right" variant="primary" size="lg" @click="submit">Submit</b-button>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {mapGetters} from 'vuex'
export default {
    name: 'Brief',
    components: {Multiselect},
    data () {
        return {
            application: null,
            error: null
        }
    },
    computed: {
        ...mapGetters({
            applications: 'tag/applications'
        }),
    },
    methods: {
        submit () {
            if (!this.application) {
                this.error = 'Please tell us what the voice over is for'
                return;
            }

            this.$store.commit('project/setApplication', this.application);

            this.$router.push({ path: '/register', query: {application: this.application.slug }});
        },
        valid (field) {
            if (this.error === null) {
                return null
            }

            if (field === '') {
                return false
            }

            return true
        },
    }
}
</script>



// WEBPACK FOOTER //
// prompts/components/project/Brief.vue